/*人员 */
import { $http, buildHeaders } from "./index";

//获取列表
export const conferee_page = (params) => {
  return $http.get("/admin/Conferee/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const conferee_detail = (id) => {
  return $http.get("/admin/Conferee/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//查看人员详情
export const conferee_search = (id) => {
  return $http.get("/admin/Conferee/detail?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};


//添加
export const conferee_add = (data) => {
  return $http.post("/admin/Conferee/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//下载模板
export const conferee_download = () => {
  return $http.get("/admin/Conferee/downloadTemplate", {
    responseType: "blob",
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//导入
export const conferee_import = (data) => {
  let headers = buildHeaders(3, "正在提交数据，请稍后……");
  headers["Content-Type"] = "multipart/form-data";
  return $http.post("/admin/Conferee/import", data, {
    headers,
  });
};

//修改
export const conferee_edit = (data) => {
  return $http.post("/admin/Conferee/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const conferee_delete = (id) => {
  return $http.post(
    "/admin/Conferee/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};
